import getWindow from '../utils/get-window'
import { track } from '../utils/tracking'

interface Experience {
  flag: string
  cohort: string
}

const trackExperimentAssigned = ({ flag, cohort }: Experience) =>
  track('Experience Bucket', `${flag}:${cohort}`, undefined, undefined, false, 'experiments')

function run() {
  const experiences = (getWindow() as any).__experiences__ ?? {}

  Object.keys(experiences).forEach((flagId: string) => {
    const experience = experiences[flagId]

    if (experience.recording === undefined || experience.recording) {
      trackExperimentAssigned({
        flag: flagId,
        cohort: experience.cohort,
      })
    }
  })
}

run()
